export class DoesEditorChangeRequireAlertUseCase {
    execute(from, to) {
        if (!from || !to) {
            return false;
        }
        const fromFileType = from.fileType;
        const toFileType = to.fileType;
        const isEitherMarkdown = fromFileType === 'md' || toFileType === 'md';
        const areBothHtml = fromFileType === 'html' && toFileType === 'html';
        if (isEitherMarkdown || areBothHtml) {
            return false;
        }
        else {
            return true;
        }
    }
}
